import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { PageHeader } from './shared';
import { CoverageManager } from './CoverageManager';
import { AreaMap } from '../components/AreaMap';

export default function AdminAreas() {
  const { coverage } = useApp();
  const [selected, setSelected] = useState(null);
  const area = coverage.find((c) => c.id === selected);
  return <div className="space-y-6">
    <PageHeader title="Zonas y tarifas" subtitle="Barrios, colonias y residenciales" />
    <AreaMap areas={coverage} selectedId={selected} geometry={area?.geometry} onAreaSelect={(zone) => setSelected(zone.id)} testId="admin-areas-map" className="h-[400px]" />
    <CoverageManager />
  </div>;
}